import { Component, Input } from '@angular/core';
import { ListItemTemplate as ListItemTemplateInterface } from '../../interfaces/list-item-template.interface';
import { ListItem } from '../../list-item';

@Component({
    selector: 'list-item-template',
    templateUrl: 'list-item-template.component.html',
    styleUrls: [ 'list-item-template.component.scss' ]
})
export class ListItemTemplate implements ListItemTemplateInterface {

    @Input() item: any;

    @Input() last: boolean;

    constructor(public listItem: ListItem) {
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/abstract-plugins/list/components/list-item-template/list-item-template.component.ts